import { render, staticRenderFns } from "./exportDataComponent.vue?vue&type=template&id=152733f0&"
import script from "./exportDataComponent.vue?vue&type=script&lang=js&"
export * from "./exportDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports